import React from "react";
import { Flex, Text, Tooltip } from "@chakra-ui/react";
import { useLingui } from "@lingui/react";
import { FiEye, FiEyeOff } from "react-icons/fi";

export type ModuleChangeStatus = "enabled" | "disabled" | "unchanged";

interface ModuleToggleIndicatorProps {
  change?: ModuleChangeStatus;
}

export const ModuleToggleIndicator: React.FC<ModuleToggleIndicatorProps> = ({
  change = "unchanged",
}) => {
  const { i18n } = useLingui();
  if (change === "unchanged") return null;

  const isEnabled = change === "enabled";
  const tooltip = isEnabled
    ? i18n._("Module was disabled during registration")
    : i18n._("Module was enabled during registration");

  return (
    <Tooltip label={tooltip} hasArrow>
      <span data-testid={`module-toggle-indicator-${change}`}>
        {isEnabled ? (
          <FiEye color="var(--chakra-colors-green-500)" />
        ) : (
          <FiEyeOff color="var(--chakra-colors-red-500)" />
        )}
      </span>
    </Tooltip>
  );
};

interface ModuleSectionHeaderProps {
  title: React.ReactNode;
  change?: ModuleChangeStatus;
  fontSize?: string;
}

export const ModuleSectionHeader: React.FC<ModuleSectionHeaderProps> = ({
  title,
  change = "unchanged",
  fontSize = "xl",
}) => {
  return (
    <Flex align="center" justify="space-between" w="full">
      <Text fontSize={fontSize} mb="2">
        {title}
      </Text>
      <ModuleToggleIndicator change={change} />
    </Flex>
  );
};
